<span class="simple-badge" [ngClass]="badgeClass">
    <mat-icon *ngIf="icon" [svgIcon]="icon" class="simple-badge__icon"></mat-icon>
    {{ label }}
</span>
